import { Box, Typography, useTheme } from '@mui/material';
import Header from '@/Components/MagicLink/Header';
import SuccessIcon from '@/Components/MagicLink/SuccessIcon';
import Section from '@/Components/MagicLink/Section';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const LinkConfirmedView = () => {
    const theme = useTheme();

    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered status block — logo sits directly above the message
                        section, sharing the card's left edge. */}
                    <Box sx={magicLinkCenteredHeroInnerSx}>
                        <Box
                            sx={{
                                width: '100%',
                                maxWidth: 480,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <Header />

                            <Section>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        gap: 2,
                                        paddingY: 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            color: theme.palette.success.main,
                                            '& svg': {
                                                stroke: 'currentColor',
                                            },
                                        }}
                                    >
                                        <SuccessIcon height={60} width={64} />
                                    </Box>
                                    <Typography variant="h5" component="h1" color={theme.palette.success.dark}>
                                        Link bol potvrdený
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Link bol úspešne potvrdený, teraz môžete zatvoriť prehliadač.
                                    </Typography>
                                </Box>
                            </Section>
                        </Box>
                    </Box>
            </Box>
        </Box>
    );
};

export default LinkConfirmedView;
